import React, { useEffect, useState, useRef } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Add from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import Attachment from "../../NewFigma/AddCustomer/attachment";
import { useStateList } from "./HandleInvoiceStateProvider";
import { showWarningSnackbar } from "../../../components/snackBar/snakbar";
import { useThemes } from "../../../components/Theme/theme";
import CustomTooltip from "../../../components/CustomTooltip";
function MultiFileAttachment({
  // itemsRows,
  // setItemsRows,
  // setInitialAttachments,
  // invoiceEntry,
  Type,

  // AddAttachmentsToDeleteList,
  // setCurrentDocuments,
}) {
  const {
    data,
    viewMode,

    invoiceEntry,

    itemsRows,
    setItemsRows,

    setInitialAttachments,
    setCurrentDocuments,
  } = useStateList();
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path =
    `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/${Type}/` +
    "${id}/";

  const updateAttachmentName = (id, newName) => {
    setItemsRows(
      itemsRows.map((attachment) =>
        attachment.attachmentid === id
          ? { ...attachment, documentname: newName }
          : attachment
      )
    );
  };
  const imageRef = useRef();
  const handleFileChange = (event) => {
    const files = event.target.files;
    const allowedTypes = [
      "application/msword",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    let allFilesValid = true;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!allowedTypes.includes(file.type)) {
        showWarningSnackbar("This format is not allowed");
        allFilesValid = false;
        break;
      }
    }

    if (allFilesValid) {
      setItemsRows((currentAttachments) => {
        if (itemsRows.length + files.length > 6) {
          showWarningSnackbar("You cannot add more than 6 attachments");
          return currentAttachments;
        }

        const newAttachments = Array.from(files).map((file) => ({
          attachmentid: currentAttachments.attachmentid
            ? currentAttachments.attachmentid
            : Date.now() + file.name,
          imagename: currentAttachments.imagename
            ? currentAttachments.imagename
            : path + Date.now() + file.name,
          documentname: file.name,
          type: currentAttachments.Type ? currentAttachments.type : file.type,
          imageurl: currentAttachments.imageurl
            ? currentAttachments.imageurl
            : URL.createObjectURL(file),
          file,
        }));

        const filteredNewAttachments = newAttachments.filter(
          (newAttachment) =>
            !currentAttachments.some(
              (attachment) =>
                attachment.documentname === newAttachment.documentname
            )
        );

        return [...currentAttachments, ...filteredNewAttachments];
      });
    } else {
      // Optionally clear the file input if invalid file detected
      event.target.value = ""; // This resets the file input
    }

    if (imageRef.current) {
      imageRef.current.value = "";
    }
  };
  function getAttachmentsOfSales(invoiceEntry) {
    if (invoiceEntry?.relatedinvoiceattachment?.length > 0) {
      let items = [];
      invoiceEntry?.relatedinvoiceattachment.map((item, ind) => {
        items.push({
          attachmentid: item.attachmentid,
          documentname: item.documentname,
          imagename: item.attachmentname,
          invoiceid: item.invoiceid,
          imageurl: item.attachmenturl,
          type: item.type,
        });
      });
      setItemsRows(items);
      setCurrentDocuments(items);
      setInitialAttachments(items);
    }
  }
  function getAttachmentsOfPurchase(invoiceEntry) {
    if (invoiceEntry?.relatedpurchaseattachment?.length > 0) {
      let items = [];
      invoiceEntry?.relatedpurchaseattachment.map((item, ind) => {
        items.push({
          attachmentid: item.attachmentid,
          documentname: item.documentname,
          imagename: item.attachmentname,
          invoiceid: item.invoiceid,
          imageurl: item.attachmenturl,
          type: item.type,
        });
      });
      setItemsRows(items);
      setCurrentDocuments(items);
    }
  }
  function getAttachmentsOfCrDr(invoiceEntry) {
    console.log(
      "invoiceEntry?.relatedcrdrattachment",
      invoiceEntry?.relatedcrdrattachment
    );

    if (invoiceEntry?.relatedcrdrattachment?.length > 0) {
      let items = [];
      invoiceEntry?.relatedcrdrattachment.map((item, ind) => {
        items.push({
          attachmentid: item.attachmentid,
          documentname: item.documentname,
          imagename: item.attachmentname,
          invoiceid: item.invoiceid,
          imageurl: item.attachmenturl,
          type: item.type,
        });
      });
      setItemsRows(items);
      setCurrentDocuments(items);
    }
  }
  useEffect(() => {
    if (invoiceEntry?.length !== 0) {
      if (Type === "Sales" || Type === "Pos") {
        getAttachmentsOfSales(invoiceEntry);
      }
      if (Type === "Purchase") {
        getAttachmentsOfPurchase(invoiceEntry);
      }
      if (Type === "CreditNote" || Type === "DebitNote") {
        getAttachmentsOfCrDr(invoiceEntry);
      }
    }
  }, [invoiceEntry]);
  const { theme } = useThemes();
  return (
    // <Box
    // className={viewMode == true ? "disable-interactions" : ""}>

    <Grid
      className={viewMode == true ? "disable-interactions" : ""}
      item
      container
      lg={12}
      style={{
        marginTop: "5px",
        justifyContent: { xs: "center", lg: "flex-start" },
      }}
    >
      <Grid>
        <Typography
          sx={{
            marginRight: "10px",
            fontWeight: "bold",
            marginBottom: "5px",
            color: data?.partyName?.value !== ""
                  ? theme?.palette?.TmId.id.toString().includes("9")
                    ? "white"
                    : "black"
                  : "gray",
          }}
          variant="h2"
        >
          Documents
        </Typography>
      </Grid>
      <Grid sx={{ display: "flex", ml: "3px", mb: "5px" }}>
        <input
          ref={imageRef}
          type="file"
          id="fileInput"
          onChange={handleFileChange}
          multiple
          disabled={data?.partyName?.value === "" ? true : false}
          style={{ display: "none" }}
          accept="
                    application/msword,
                    application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.ms-excel,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    application/vnd.ms-powerpoint,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    image/jpeg,
                    image/png
                  "
        />
        {!viewMode && (

          <CustomTooltip title="Rolling out soon" placement="top">
            <span>
             <Button
            onClick={() => imageRef?.current?.click()}
            size="small"
            variant="contained"
            disableRipple={false}
            // disabled={data?.partyName?.value === "" ? true : false}
            disabled = {true}
            sx={{
              fontSize: "12px",
              padding: "0px 5px",
              marginBottom: "5px",
              boxShadow: "none",
              marginTop: "-3px",
              display: viewMode ? "none" : "block",
            }}
          >
            <Add fontSize="15px" />
            {" ADD DOCUMENT"}
            {itemsRows.length > 0 && (
              <span style={{ color: "white" }}>
                {"\xa0" + `(${itemsRows.length} out of 6)`}
              </span>
            )}
          </Button>
            </span>
          </CustomTooltip>
       
        )}
      </Grid>
        {itemsRows.length > 0 &&(
        <Grid item lg={12} md={12} xs={12}>
          <Attachment
            view={viewMode}
            attachments={itemsRows}
            setAttachments={setItemsRows}
            updateAttachmentName={updateAttachmentName}
          />
       </Grid>
         )
      }
     
    </Grid>
    // </Box>
  );
}

export default MultiFileAttachment;
